'use client';

import React, { useEffect, useState } from 'react';
import { recordImpression } from '@/actions/public/server.actions';
import useConnectModalStore from '@/components/store/connectModalSlice';
import useUserProfile from '@/hooks/useUserProfile';
import Button from '@ui/Button';
import { communityApplicationStatus } from '@/actions/server.actions';
import JoinCommunityButton from '@/components/next-page-components/JoinCommunityButton';
import ShareButton from '@/components/next-page-components/ShareButton';

function HeaderButtons({ company }) {
  const user = useUserProfile();
  const communities = user?.communities;
  const [applicationExists, setApplicationExists] = useState({});

  let recordShareClickPayload = {
    type: 'company_public_page',
    companyId: company.id,
    shareClick: {
      userId: user?.id,
      activeCommunityId: user?.activeCommunity?.id,
      location: user?.location,
    },
  };

  const handleIsUserInCommunity = (id) => {
    return communities?.some(
      (community) =>
        community.id === id ||
        community.groups?.some((group) => group.id === id),
    );
  };

  const setShowConnectModal = useConnectModalStore((state) => state.setOpen);

  const handleConnect = () => {
    setShowConnectModal(true, company);
  };

  const getApplicationStatus = async () => {
    const data = await communityApplicationStatus(user?.email, company?.id);
    setApplicationExists(data);
  };

  useEffect(() => {
    getApplicationStatus();
  }, [company]);

  return (
    <div className="flex gap-2 self-end px-6 lg:self-start lg:pl-0 lg:pr-4">
      {/* <Button variant="filled" color="primary" onClick={handleConnect}>
        Connect
      </Button> */}
      {!handleIsUserInCommunity(company?.id) && (
        <JoinCommunityButton
          variant="filled"
          community={company}
          pendingApproval={applicationExists?.status === 'pending'}>
          Join
        </JoinCommunityButton>
      )}

      <ShareButton variant="text" recordPayload={recordShareClickPayload} />
    </div>
  );
}

export default HeaderButtons;
